import { EBitfStoreActions } from '@common/enums';
export enum EWebStoreActions {
  SET_BRANDS = 'SET_BRANDS',
  SET_BRAND_ID = 'SET_BRAND_ID',
}

export const eStoreActions = { ...EBitfStoreActions, ...EWebStoreActions };
